var _style, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFindDisorder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    id: "freepik_stories-breast-cancer-research",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 463.39 435.19",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "svg#freepik_stories-breast-cancer-research:not(.animated) .animable {opacity: 0;}svg#freepik_stories-breast-cancer-research.animated #freepik--background-simple--inject-110 {animation: 1.5s Infinite  linear floating;animation-delay: 0s;}svg#freepik_stories-breast-cancer-research.animated #freepik--Equipment--inject-110 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideRight;animation-delay: 0s;}svg#freepik_stories-breast-cancer-research.animated #freepik--device-2--inject-110 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideRight;animation-delay: 0s;}svg#freepik_stories-breast-cancer-research.animated #freepik--Bottles--inject-110 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideRight;animation-delay: 0s;}svg#freepik_stories-breast-cancer-research.animated #freepik--Table--inject-110 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideRight;animation-delay: 0s;}svg#freepik_stories-breast-cancer-research.animated #freepik--device-1--inject-110 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideRight;animation-delay: 0s;}svg#freepik_stories-breast-cancer-research.animated #freepik--Character--inject-110 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideRight;animation-delay: 0s;}svg#freepik_stories-breast-cancer-research.animated #freepik--Ribbon--inject-110 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideRight;animation-delay: 0s;}            @keyframes floating {                0% {                    opacity: 1;                    transform: translateY(0px);                }                50% {                    transform: translateY(-10px);                }                100% {                    opacity: 1;                    transform: translateY(0px);                }            }                    @keyframes slideRight {                0% {                    opacity: 0;                    transform: translateX(30px);                }                100% {                    opacity: 1;                    transform: translateX(0);                }            }        ")), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-110",
    className: "animable",
    style: {
      transformOrigin: "253.234px 258.551px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "elfyya8fgso77"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M462.11,146s-27.77-64.8-85.36-90.51-91.54-5.15-132.68,20.57-135.77,7.2-174.85,28.8-57.6,74.05-37,132.67S106.25,340.41,93.9,369.21,197.78,504,294.46,464.86s71-82.28,115.2-101.82,75.08-72,73-135.76S462.11,146,462.11,146Z",
    style: {
      fill: "#4090B9",
      transformOrigin: "253.234px 258.551px"
    },
    className: "animable",
    id: "elmnace1w85ci"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elzop0el2dkps"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M462.11,146s-27.77-64.8-85.36-90.51-91.54-5.15-132.68,20.57-135.77,7.2-174.85,28.8-57.6,74.05-37,132.67S106.25,340.41,93.9,369.21,197.78,504,294.46,464.86s71-82.28,115.2-101.82,75.08-72,73-135.76S462.11,146,462.11,146Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.8,
      transformOrigin: "253.234px 258.551px"
    },
    className: "animable",
    id: "eljga1hlhoyue"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Equipment--inject-110",
    className: "animable",
    style: {
      transformOrigin: "295.79px 181.81px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "el5sdf43cf417"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M361,143.73l-6.72-26.09V110.5h-9.51v7.14L338,143.73a2.77,2.77,0,0,0,2.68,3.46h17.59A2.77,2.77,0,0,0,361,143.73Z",
    style: {
      fill: "rgb(189, 189, 189)",
      transformOrigin: "349.5px 128.845px"
    },
    className: "animable",
    id: "elfjl9f9j83s6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elxfma0b0ab5f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M355.47,130.54h-12L340,144.24a.72.72,0,0,0,.13.63.72.72,0,0,0,.57.28h17.59a.74.74,0,0,0,.58-.28.72.72,0,0,0,.13-.63Z",
    style: {
      fill: "gray",
      transformOrigin: "349.5px 137.845px"
    },
    className: "animable",
    id: "elnwe0bcx30i"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el6dekwrx249s"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M401.58,143.73l-6.72-26.09V110.5h-9.51v7.14l-6.72,26.09a2.77,2.77,0,0,0,2.68,3.46H398.9A2.77,2.77,0,0,0,401.58,143.73Z",
    style: {
      fill: "rgb(189, 189, 189)",
      transformOrigin: "390.105px 128.845px"
    },
    className: "animable",
    id: "elg0ajiy3ulx7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elcylqdbwl9ub"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M396.08,130.54H384.13l-3.53,13.7a.73.73,0,0,0,.71.91H398.9a.73.73,0,0,0,.71-.91Z",
    style: {
      fill: "gray",
      transformOrigin: "390.105px 137.845px"
    },
    className: "animable",
    id: "elz4fgvnigu9"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 329.44,
    y1: 78.33,
    x2: 329.44,
    y2: 0.5,
    style: {
      fill: "none",
      stroke: "rgb(189, 189, 189)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "329.44px 39.415px"
    },
    id: "elrsrfs7rmr7o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.47,
    y: 108.85,
    width: 257.62,
    height: 151.72,
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "295.28px 184.71px"
    },
    id: "el90hjhczpca8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.59,
    y: 114.88,
    width: 243.38,
    height: 145.7,
    style: {
      fill: "rgb(189, 189, 189)",
      transformOrigin: "295.28px 187.73px"
    },
    id: "elkedbv6eyjgo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "303.59 173.6 312.36 185.65 380.27 185.65 389.6 173.6 303.59 173.6",
    style: {
      fill: "gray",
      transformOrigin: "346.595px 179.625px"
    },
    id: "elew2yy9750k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.04,
    y: 180.47,
    width: 52.72,
    height: 5.18,
    style: {
      fill: "rgb(92, 92, 92)",
      transformOrigin: "347.4px 183.06px"
    },
    id: "elmk7bafa36w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252.48,
    y: 153.59,
    width: 43.27,
    height: 13.1,
    style: {
      fill: "gray",
      transformOrigin: "274.115px 160.14px"
    },
    id: "elkktajg2jmu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.94,
    y: 135.84,
    width: 6.4,
    height: 15.66,
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "318.14px 143.67px"
    },
    id: "el1yqy2c4rko9k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.35,144.07h11.59a3.8,3.8,0,0,1,3.8,3.8v20.27a0,0,0,0,1,0,0h-19.2a0,0,0,0,1,0,0V147.87A3.8,3.8,0,0,1,312.35,144.07Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "318.14px 156.105px"
    },
    id: "elgx2ka02n6kf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.3,
    y: 135.84,
    width: 6.4,
    height: 15.66,
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "344.5px 143.67px"
    },
    id: "elm6ct5s7r2xj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.71,144.07H350.3a3.8,3.8,0,0,1,3.8,3.8v20.27a0,0,0,0,1,0,0H334.9a0,0,0,0,1,0,0V147.87A3.8,3.8,0,0,1,338.71,144.07Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "344.5px 156.105px"
    },
    id: "elpo2ot7lzqc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 367.66,
    y: 135.84,
    width: 6.4,
    height: 15.66,
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "370.86px 143.67px"
    },
    id: "elp8f1s24s6b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.06,144.07h11.59a3.8,3.8,0,0,1,3.8,3.8v20.27a0,0,0,0,1,0,0h-19.2a0,0,0,0,1,0,0V147.87A3.8,3.8,0,0,1,365.06,144.07Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "370.85px 156.105px"
    },
    id: "el203csfoju27",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252.48,
    y: 142.31,
    width: 43.27,
    height: 11.27,
    style: {
      fill: "rgb(163, 163, 163)",
      transformOrigin: "274.115px 147.945px"
    },
    id: "elsorpbexe0t",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.59,
    y: 165.81,
    width: 243.38,
    height: 9.86,
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "295.28px 170.74px"
    },
    id: "elx1c54bhidd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.39,
    y: 211.28,
    width: 16.84,
    height: 51.35,
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "366.81px 236.955px"
    },
    id: "eltmy7dr6nxz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327.58,
    y: 186.22,
    width: 78.46,
    height: 64.91,
    style: {
      fill: "rgb(84, 84, 84)",
      transformOrigin: "366.81px 218.675px"
    },
    id: "elqsnhrjsstfg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.04,
    y: 190.74,
    width: 67.54,
    height: 55.87,
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "366.81px 218.675px"
    },
    id: "els6emr6hdz8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.11,
    y: 229.35,
    width: 20.54,
    height: 4.52,
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "218.38px 231.61px"
    },
    id: "el5w1fta830w4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elba19uok1875"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M199.78,300.44V290.31a10.25,10.25,0,0,1,3.52-7.73l12.5-10.9h45.6l11.88,10.92a10.27,10.27,0,0,1,3.32,7.55v11.93Z",
    style: {
      fill: "rgb(196, 196, 196)",
      transformOrigin: "238.19px 286.88px"
    },
    className: "animable",
    id: "el7spzospnaqh"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elue2oysr639"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M260.17,284.62c0,4.2-9.84,7.6-22,7.6s-22-3.4-22-7.6,9.84-7.6,22-7.6S260.17,280.42,260.17,284.62Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "238.17px 284.62px"
    },
    className: "animable",
    id: "elde745lt7nf8"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 166.47,
    y: 260.57,
    width: 258.64,
    height: 102.55,
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "295.79px 311.845px"
    },
    id: "elqujr2ogbc5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 166.38,
    y1: 313.97,
    x2: 423.95,
    y2: 313.97,
    style: {
      fill: "none",
      stroke: "gray",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "295.165px 313.97px"
    },
    id: "el2daxzeqeirk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.67,
    y: 260.57,
    width: 80.43,
    height: 102.55,
    style: {
      fill: "rgb(189, 189, 189)",
      transformOrigin: "384.885px 311.845px"
    },
    id: "elpk9mlpc2ko",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.46,
    y: 260.57,
    width: 268.66,
    height: 9.86,
    style: {
      fill: "gray",
      transformOrigin: "295.79px 265.5px"
    },
    id: "eluzcrfuehd0g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "292.91 270.52 296.97 278.01 320.05 278.01 324.13 270.52 292.91 270.52",
    style: {
      fill: "gray",
      transformOrigin: "308.52px 274.265px"
    },
    id: "elwpshwuerb2q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "292.91 313.65 296.97 321.14 320.05 321.14 324.13 313.65 292.91 313.65",
    style: {
      fill: "gray",
      transformOrigin: "308.52px 317.395px"
    },
    id: "el5x8a3wnixts",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "206.23 270.52 210.29 278.01 233.38 278.01 237.45 270.52 206.23 270.52",
    style: {
      fill: "gray",
      transformOrigin: "221.84px 274.265px"
    },
    id: "el00ydqxf0tacil",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "206.23 313.65 210.29 321.14 233.38 321.14 237.45 313.65 206.23 313.65",
    style: {
      fill: "gray",
      transformOrigin: "221.84px 317.395px"
    },
    id: "el020l6hs5xuqv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 324.32,
    y1: 27.21,
    x2: 395.82,
    y2: 27.21,
    style: {
      fill: "none",
      stroke: "rgb(189, 189, 189)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "360.07px 27.21px"
    },
    id: "elhb9yra13dpv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 317.99,
    y1: 27.21,
    x2: 324.32,
    y2: 27.21,
    style: {
      fill: "none",
      stroke: "rgb(189, 189, 189)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3,
      transformOrigin: "321.155px 27.21px"
    },
    id: "elu9xuqbt5feg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 370.64,
    y1: 27.97,
    x2: 370.64,
    y2: 76.04,
    style: {
      fill: "none",
      stroke: "rgb(189, 189, 189)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "370.64px 52.005px"
    },
    id: "el5u8w10vxsbh",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--device-2--inject-110",
    className: "animable",
    style: {
      transformOrigin: "92.885px 286.63px"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "103.78 356.75 103.78 210.4 72.77 210.4 72.77 356.75 62.82 356.75 62.82 362.86 72.77 362.86 103.78 362.86 113.74 362.86 113.74 356.75 103.78 356.75",
    style: {
      fill: "rgb(196, 196, 196)",
      stroke: "rgb(184, 184, 184)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "88.28px 286.63px"
    },
    id: "el3afrb111qsw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.68,
    y: 210.4,
    width: 159.19,
    height: 118.93,
    style: {
      fill: "rgb(196, 196, 196)",
      stroke: "rgb(184, 184, 184)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "88.275px 269.865px"
    },
    id: "el2ohggxyea4o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.68,
    y: 215.63,
    width: 145.19,
    height: 108.47,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(184, 184, 184)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "88.275px 269.865px"
    },
    id: "eluuccleaht5r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el3avv5h60h4l"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.62,255.42S100,268.34,98.45,273s-11.75,4.7-22.72,7.44S56.15,291.84,54.19,307.9c-.52,4.28-6.66,52.49-6.66,52.49",
    style: {
      fill: "none",
      stroke: "rgb(184, 184, 184)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "73.5956px 307.905px"
    },
    className: "animable",
    id: "eluie2vy9trqg"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eli189nnbxjyj"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125,255.42s-.39,12.92,1.17,17.62,11.75,4.7,22.72,7.44,19.58,11.36,21.54,27.42c.52,4.28,6.66,52.49,6.66,52.49",
    style: {
      fill: "none",
      stroke: "rgb(184, 184, 184)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "151.023px 307.905px"
    },
    className: "animable",
    id: "el8ahqv31yuq6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elv9wrmr5j9nm"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.72,360.39s2.74-12.93,3.53-19.59,3.52-19.19,3.52-19.19-.78,16.45,1.57,24.68A113.36,113.36,0,0,1,78.47,360",
    style: {
      fill: "none",
      stroke: "rgb(184, 184, 184)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "72.595px 341px"
    },
    className: "animable",
    id: "elnzuyl2rilic"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el2dyipk4ckp"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.24,360.39s-2.74-12.93-3.53-19.59-3.52-19.19-3.52-19.19.78,16.45-1.57,24.68A113.36,113.36,0,0,0,143.49,360",
    style: {
      fill: "none",
      stroke: "rgb(184, 184, 184)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "149.365px 341px"
    },
    className: "animable",
    id: "elu6bbcnvkycd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el8dx94e6kn4r"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.77,332.87a19.31,19.31,0,0,0,26.8,17.78",
    style: {
      fill: "none",
      stroke: "rgb(184, 184, 184)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "87.17px 342.516px"
    },
    className: "animable",
    id: "eldis0rcjp9xc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el51gu29pjx29"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.15,332.87a19.31,19.31,0,0,1-26.8,17.78",
    style: {
      fill: "none",
      stroke: "rgb(184, 184, 184)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "134.75px 342.516px"
    },
    className: "animable",
    id: "elpmmhfdbgm28"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottles--inject-110",
    className: "animable",
    style: {
      transformOrigin: "78.8665px 369.036px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "el10lsbxbmvy8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.51,396.25l-9.89-38.41v-10.5h-14v10.5l-9.89,38.41a4.08,4.08,0,0,0,4,5.09H68.57A4.07,4.07,0,0,0,72.51,396.25Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "55.6214px 374.34px"
    },
    className: "animable",
    id: "elp7apwgvfx1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elogqqihqza5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.42,376.84H46.83L41.64,397a1,1,0,0,0,.19.92,1,1,0,0,0,.85.42H68.57a1,1,0,0,0,.84-.42,1,1,0,0,0,.2-.92Z",
    style: {
      fill: "#4090B9",
      transformOrigin: "55.6237px 387.59px"
    },
    className: "animable",
    id: "elx6dn8srm4w"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elxgyks15ulth"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.38,365V342.84h-13V365a18.75,18.75,0,1,0,13,0Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "85.88px 372.089px"
    },
    className: "animable",
    id: "elxg012ag0k0a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el97rsk919rqj"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.83,377.84a16.54,16.54,0,0,0-.7,4.75,16.75,16.75,0,0,0,33.5,0,16.53,16.53,0,0,0-.69-4.75Z",
    style: {
      fill: "#4090B9",
      transformOrigin: "85.88px 388.59px"
    },
    className: "animable",
    id: "elscq5dxh5fm9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elenu9ikhc3yw"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.05,377.37V336.73h-8.58v40.64a12.37,12.37,0,1,0,8.58,0Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "106.76px 369.036px"
    },
    className: "animable",
    id: "elqa1o6q4w6re"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elxbzilw71e0j"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.16,385.83A11.05,11.05,0,1,0,117.81,389a10.77,10.77,0,0,0-.46-3.13Z",
    style: {
      fill: "#4090B9",
      transformOrigin: "106.76px 392.915px"
    },
    className: "animable",
    id: "elr9prxwi05jd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-110",
    className: "animable",
    style: {
      transformOrigin: "226.07px 363.12px"
    }
  }, /*#__PURE__*/React.createElement("line", {
    x1: 451.64,
    y1: 363.12,
    x2: 0.5,
    y2: 363.12,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "226.07px 363.12px"
    },
    id: "el3pgglowm4fg",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--device-1--inject-110",
    className: "animable",
    style: {
      transformOrigin: "176.974px 301.315px"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "160.27 250.18 111.23 270.54 111.23 346.42 129.74 346.42 129.74 275.17 163.97 256.2 160.27 250.18",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "137.6px 298.3px"
    },
    id: "elraaivwnn9ml",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elqaq3j5wzcr"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M205.23,360.64a1.9,1.9,0,0,1,0-3.47,1.91,1.91,0,0,0-1.91-1.91H187a8.14,8.14,0,0,1-1.91,5.38,1.9,1.9,0,0,1,0,3.47,1.9,1.9,0,0,1,0,3.47,1.9,1.9,0,0,1,0,3.47A1.91,1.91,0,0,0,187,373h16.31a7.93,7.93,0,0,1,1.91-5.37,1.9,1.9,0,0,1,0-3.47,1.9,1.9,0,0,1,0-3.47Z",
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "195.16px 364.13px"
    },
    className: "animable",
    id: "el2b4fscojnl"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 110.88,
    y: 334.39,
    width: 89.87,
    height: 18.39,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "155.815px 343.585px"
    },
    id: "eljgzp8zmdz1g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.88,
    y: 343.06,
    width: 89.87,
    height: 9.72,
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "155.815px 347.92px"
    },
    id: "el8dm5os81xh2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.78,
    y: 352.43,
    width: 10.76,
    height: 10.06,
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "122.16px 357.46px"
    },
    id: "elkz3nkyd1shi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.4,
    y: 352.43,
    width: 10.76,
    height: 10.06,
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "154.78px 357.46px"
    },
    id: "el7cfygqltk5t",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.02,
    y: 352.43,
    width: 10.76,
    height: 10.06,
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "187.4px 357.46px"
    },
    id: "el1azyfijad17",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.68,
    y: 298.99,
    width: 79.81,
    height: 4.16,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "162.585px 301.07px"
    },
    id: "elnvsrpithq3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.62,
    y: 302.81,
    width: 68.36,
    height: 6.25,
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "163.8px 305.935px"
    },
    id: "elb11iydgsis",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elnke4dahde9i"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 210.23,
    y: 228.26,
    width: 11.1,
    height: 63.85,
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "215.78px 260.185px",
      transform: "rotate(-132.5deg)"
    },
    className: "animable",
    id: "elsdbhiczdras"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elqdnt0ekxdm"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 195.9,
    y: 255.39,
    width: 15.88,
    height: 31.46,
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "203.84px 271.12px",
      transform: "rotate(-132.5deg)"
    },
    className: "animable",
    id: "elff8ryfs3bk4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el54rmx9wfhs"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 188.9,
    y: 300.58,
    width: 8.79,
    height: 22.67,
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "193.295px 311.915px",
      transform: "rotate(180deg)"
    },
    className: "animable",
    id: "el97swl2bs1wf"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ellamw7xf0x9"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 189.85,
    y: 323.56,
    width: 6.83,
    height: 3.79,
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "193.265px 325.455px",
      transform: "rotate(180deg)"
    },
    className: "animable",
    id: "elon26y05pq2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elp3d39u9q04c"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 175.88,
    y: 294.49,
    width: 8.79,
    height: 22.67,
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "180.275px 305.825px",
      transform: "rotate(-156.26deg)"
    },
    className: "animable",
    id: "elnotk8xpds5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elasvfwr9vf4j"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 171.38,
    y: 316.31,
    width: 6.83,
    height: 3.79,
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "174.795px 318.205px",
      transform: "rotate(-156.26deg)"
    },
    className: "animable",
    id: "elnsvlnpkzjhf"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "173.56 229.63 187.65 243.94 185.29 267.76 155.68 260.36 153.2 240.28 173.56 229.63",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "170.425px 248.695px"
    },
    id: "elm6kskwzgffj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "155.68 253.48 185.29 261.14 185.29 267.76 155.68 260.36 155.68 253.48",
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "170.485px 260.62px"
    },
    id: "elyh315mp4er",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-110",
    className: "animable",
    style: {
      transformOrigin: "285.908px 285.066px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "elc746ben3ml9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M277.17,358.85l7.4,42.53H432c-4.71-25.47-19.09-99.82-29.19-116.64-12.22-20.38-38.53-37.05-48.17-41.13s-16.16-6.92-16.16-6.92-26.08-3.08-46.09,20.63c0,0-24.08,25.57-31.12,36.69s-18.7,59.86-18.7,59.86-4.81-1.85-6.29.74-3.34,5.93-4.08,7.41S217,368,214,370.17c-34.91,26.19-16.54,34.25-13.81,28.62l49.38,1.81s18.9-21.53,22.61-23.39S277.17,358.85,277.17,358.85Z",
    style: {
      fill: "#4090B9",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "312.465px 318.969px"
    },
    className: "animable",
    id: "elpmsstqy9qoc"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 257.78,
    y1: 320.63,
    x2: 245.46,
    y2: 271.72,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "251.62px 296.175px"
    },
    id: "el8hmc9brw07y",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eljxnjzv5t5td"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M249.47,357.6c5.45,3.67,15.88,10.56,15.19,9-.93-2.09-4.42-4.89-5.12-5.35",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "257.081px 362.213px"
    },
    className: "animable",
    id: "elf6ds43j8ao"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elxab8oh1zo5e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M246.26,355.42l1.29.88",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "246.905px 355.86px"
    },
    className: "animable",
    id: "eliuumhvmmipd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ellgp0gqsuxuh"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M246.2,375.74a32.77,32.77,0,0,0,3.09,3",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "247.745px 377.24px"
    },
    className: "animable",
    id: "elyjxowybbns"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elx01vqewx3ds"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M234.38,363.34s5.34,5.7,9.64,10.15",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "239.2px 368.415px"
    },
    className: "animable",
    id: "el9bpay1985z"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 242.79,
    y1: 289.78,
    x2: 248.3,
    y2: 293.91,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "245.545px 291.845px"
    },
    id: "el341nnq8exxt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 254.89,
    y1: 309.82,
    x2: 244.69,
    y2: 292.93,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "249.79px 301.375px"
    },
    id: "eln22lex82eug",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eld1qleupn91i"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M289.93,258.23s-9.34,27.24-10.38,31.65l5.19,3.64s-9.86,14.78-9.34,16.6c.42,1.47,11.37,35.74,17.05,52.06",
    style: {
      fill: "#4090B9",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "283.915px 310.205px"
    },
    className: "animable",
    id: "elucmqlt5mm3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el2v6o0gchiak"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M326.77,234.36s1.56-3.12,2.86-2.6,8.56,3.12,8.82,4.93S341.3,279,341.3,279l-20,5.44,9.34,13.24s-6,16.6-20.23,25.68a275.26,275.26,0,0,1-24.39,14l7-15.83",
    style: {
      fill: "#4090B9",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "313.66px 284.531px"
    },
    className: "animable",
    id: "elra81eu5rf1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el9bvtkv7bnh8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M293.66,365.6c.76,2.1,1.35,3.66,1.72,4.46",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "294.52px 367.83px"
    },
    className: "animable",
    id: "elyab0ssw3abm"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el94zlid2p2im"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.92,376.2s-18.3-4.75-21.63-1.48c-16.49,16.2-18.7,22.25-18.18,26,.35,2.62,38.27,1,38.27,1s7.44-12.3,8.91-17.22S235.69,377.51,231.92,376.2Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "215.797px 387.893px"
    },
    className: "animable",
    id: "elrhhjy9eiim"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elsyuoj19kz1f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M198.5,401.4c11.31-18.93,7.83-14.76,14.89-22.6",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "205.945px 390.1px"
    },
    className: "animable",
    id: "el1ox8i0siylm"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elp5vas9dnkml"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M208,401.58s10.62-17.74,15.89-22.78",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "215.945px 390.19px"
    },
    className: "animable",
    id: "elw60mc9rggx"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elm343tfevs2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M220.52,401.58s8.69-15.67,11.9-20.26",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "226.47px 391.45px"
    },
    className: "animable",
    id: "elge8wawoggd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el0d0sgx8cfsb9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M239.36,385.68a44.72,44.72,0,0,1,4.06,4.35c1.61,2.07,3.21,6,3.21,8s-3,3.78-4,3.78c-1.78,0-.86,0-12.29-.07l7.77-14.68Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "238.485px 393.745px"
    },
    className: "animable",
    id: "elllhloo4kck"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elhtqymkup0fh"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M234.12,395s4.23-1.61,6.65-1.41",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "237.445px 394.286px"
    },
    className: "animable",
    id: "el06py7igg4mv6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elaavxc4jv7m"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M230.64,214.08s3.22,13.42,4.83,15.56,6.44,7,7,9.93-.81,14.49,1.88,15.57,8.85,0,8.85,0,14,13.42,16.37,13.42,15.84-10.74,15.84-10.74l7.51,5.37s-4.29,18.25-3.22,31.94,3.22,24.95,5.37,22.81,23.35-35.16,26.83-51.53,7.25-31.67,7.25-31.67l-12.34-4.83s-18.79-6.17-30.6-7.78-26-9.13-36.5-14.23-17.17-4.83-18.51-3.75S230.64,214.08,230.64,214.08Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "279.782px 260.855px"
    },
    className: "animable",
    id: "el367x9pvl6hr"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el9m73jbnuh4f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M236.74,236.69a81.29,81.29,0,0,1,23.87-16.09",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3,
      transformOrigin: "248.675px 228.645px"
    },
    className: "animable",
    id: "ely6wsmwswqe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el2mn864mcmdw"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M238.55,234.88s3.89,5.44,6.23,7.52,6.49,2.34,11.42-.52,7.26-14,6.48-17.12-4.67-2.63-4.67-2.63Z",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "250.689px 233.048px"
    },
    className: "animable",
    id: "el191lfem9zuv"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ela48l8brevq"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M230.91,207.37s20.39,8,27.1,14.76,35.43,5.9,38.11,6.17,4.3,2.68,14,4.29,20.39-2.41,23.34-11.53-9.92-15.3-11-16.64-12.88-33.82-26.57-41.87-32.47-6.44-47.23,4.83-21.47,24.42-23.08,26.84-11.54,5.1-7.25,12.34,11.54,7.25,12.35,7.52S230.91,207.37,230.91,207.37Z",
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "275.581px 195.228px"
    },
    className: "animable",
    id: "el0wa2drazm5tf"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elz61o5i94t2b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M250,234.51c1,1.45,1.41,3,.83,3.39s-1.9-.42-2.94-1.88-1.42-3-.84-3.39S248.94,233.05,250,234.51Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "248.937px 235.265px"
    },
    className: "animable",
    id: "elwfvq3u5pfgi"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elkj54v2pzk9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M242.44,229.43s2.08-5.45,6.75-5.71",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "245.815px 226.575px"
    },
    className: "animable",
    id: "el3ttm9815ybr"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elbewegvtpy97"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M293.56,228.65s1.3,2.85-.26,4.93-4.93,2.59-4.93,2.59l-.78,7.53",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "290.829px 236.175px"
    },
    className: "animable",
    id: "elrmbgva3qkh"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "265.99 219.6 272.61 214.04 273.51 224.97 265.99 219.6",
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "269.75px 219.505px"
    },
    id: "elh2fwhqf41yr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 273.51,
    y1: 224.97,
    x2: 283.51,
    y2: 232.98,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "278.51px 228.975px"
    },
    id: "el927wix7y5ej",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elm498ft6tx3h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259,377.75s-50.39-4.08-53.36-6.3-24.41-17.31-26.19-18.5-20.45-1.18-21.93-1.18-15.12,6.52-16.9,9.19-.3,5,1.48,4.74a40.27,40.27,0,0,0,5-1.48s-2.37,8-2.37,9.48,4.15,4.45,4.15,4.45-1.78,2.67,0,3.85,6.52-.29,6.52-.29,6.23-5,7.12-5,8.89,1.18,8.89,1.18,9.19,8,13.64,10.08a25.37,25.37,0,0,0,9.48,2.08l64.8,14.05Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "199.573px 377.935px"
    },
    className: "animable",
    id: "el9h7g2nmcjzq"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elp6v8vpcp83b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M228.26,388.12c1-3.84.52-9.08-.12-13.23-11.09-1.18-21.21-2.48-22.49-3.44-3-2.22-24.41-17.31-26.19-18.5s-20.45-1.18-21.93-1.18-15.12,6.52-16.9,9.19-.3,5,1.48,4.74a40.27,40.27,0,0,0,5-1.48s-2.37,8-2.37,9.48,4.15,4.45,4.15,4.45-1.78,2.67,0,3.85,6.52-.29,6.52-.29,6.23-5,7.12-5,8.89,1.18,8.89,1.18,9.19,8,13.64,10.08a25.37,25.37,0,0,0,9.48,2.08l29.74,8.13A49.36,49.36,0,0,0,228.26,388.12Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "184.33px 374.975px"
    },
    className: "animable",
    id: "eldqoo2q4w82w"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elmbt0omqc4ff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.15,364.22a51.16,51.16,0,0,1,7.41-4.31c4.18-2,9.52-5.6,12.78-5.34a26,26,0,0,0,4.31.13",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "159.4px 359.388px"
    },
    className: "animable",
    id: "elcusxdz2q6oi"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el375zl6fg7nn"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.91,377.13s-1-2.22-.52-3.26,2.74-7.57,3.26-8.09,16.56-6,18-6.52a7.49,7.49,0,0,1,4-.26",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "159.955px 367.986px"
    },
    className: "animable",
    id: "elzgcf0w9sqc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el85vjpfzg075"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.93,378.15s4.72-5.85,6.16-7.41,15.91-3.91,17.73-4",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "160.875px 372.445px"
    },
    className: "animable",
    id: "elpnnjjlpujj"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elue9zxejx2rb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M206.86,384.25s-.57,5.46-3.67,7.63",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "205.025px 388.065px"
    },
    className: "animable",
    id: "elwtpv2u0sd88"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elpyz0y3ly0m"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M209.91,381.8s-.91,4-1.83,6.72",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "208.995px 385.16px"
    },
    className: "animable",
    id: "elv5leyvyadve"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el0ttko4jvp3b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M363.14,264s-14.83,8.52-20,19.27S342,298.82,342,298.82L324.6,363.3s-10.75,1.85-11.12,4.81-1.11,6.3-1.11,6.3l-10.74,2.23-8.53-3-39.27,1.48v34.09S352,413,356.1,412.58s6.67-5.56,7.78-9.63,31.86-97.09,31.86-97.09",
    style: {
      fill: "#4090B9",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "324.785px 338.306px"
    },
    className: "animable",
    id: "elj1zh2bjll9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elwfjlayfka6g"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M322.55,377.94a75.89,75.89,0,0,1,9.83,6.85c7,5.93,13.34,6.3,7.78-.74a23.56,23.56,0,0,0-14.08-8.15",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "332.416px 382.592px"
    },
    className: "animable",
    id: "elbe31n2nlkqp"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el55zdeu94dmg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M316.08,374.41s1.47.71,3.69,1.94",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "317.925px 375.38px"
    },
    className: "animable",
    id: "elpfdjb3228m"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elt5gruejjllo"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M302,379.23s5.93,11.49,8.15,15.93-1.11-9.63-1.11-9.63",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "306.457px 387.628px"
    },
    className: "animable",
    id: "ell53a75quycm"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eljk58cf0rot8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M370.65,277.84a23.28,23.28,0,0,1,4.34-.51",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "372.82px 277.585px"
    },
    className: "animable",
    id: "elnghwbu82iz"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elk2m07x1pmc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M344.61,297.71s8.52-12.78,20.64-18.1",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "354.93px 288.66px"
    },
    className: "animable",
    id: "el7er0iptvpii"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eljoa2mgi1p2s"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M329.4,219.71s20.13-6.44,23.08,3.49-.81,11-.81,11,15.57-7.79,20.94,1.34,2.68,9.12,4.83,10.73,13.95-7,21.47,4.3-3.76,22.81-3.76,22.81-27.11-21.2-44.82-27.91-26.57-8.59-31.13-14.23S329.4,219.71,329.4,219.71Z",
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "359.91px 245.518px"
    },
    className: "animable",
    id: "elvunfdnwulg"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elbdhff6aw1uv"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M375.36,367.37s20-10.37,30.76-24.08",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "390.74px 355.33px"
    },
    className: "animable",
    id: "elvfieywwcubj"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el3x4ung7xg5k"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M404.81,358c1.5-.72,2.83-1.42,3.9-2.06",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "406.76px 356.97px"
    },
    className: "animable",
    id: "elavpxvkp6bd6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el1kr8t9vzfxzj"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M381.29,367.37s11.36-4,20.13-7.86",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "391.355px 363.44px"
    },
    className: "animable",
    id: "el30keln25cz6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Ribbon--inject-110",
    className: "animable",
    style: {
      transformOrigin: "109.58px 157.105px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "ela6aywnph27r"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.67,96.36c16.31,0,29.93,14.56,33.22,34a53.91,53.91,0,0,0,.77-9.08c0-23.79-15.22-43.07-34-43.07s-34,19.28-34,43.07a55,55,0,0,0,.76,9.08C79.74,110.92,93.36,96.36,109.67,96.36Z",
    style: {
      fill: "#4090B9",
      transformOrigin: "109.66px 104.285px"
    },
    className: "animable",
    id: "el1e5kkrdz85q"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elvxwlz3x76u"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.67,96.36c16.31,0,29.93,14.56,33.22,34a53.91,53.91,0,0,0,.77-9.08c0-23.79-15.22-43.07-34-43.07s-34,19.28-34,43.07a55,55,0,0,0,.76,9.08C79.74,110.92,93.36,96.36,109.67,96.36Z",
    style: {
      opacity: 0.27,
      transformOrigin: "109.66px 104.285px"
    },
    className: "animable",
    id: "elr848u76mzsj"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elzrxkh27r35b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.67,96.36c16.31,0,29.93,14.56,33.22,34a53.91,53.91,0,0,0,.77-9.08c0-23.79-15.22-43.07-34-43.07s-34,19.28-34,43.07a55,55,0,0,0,.76,9.08C79.74,110.92,93.36,96.36,109.67,96.36Z",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "109.66px 104.285px"
    },
    className: "animable",
    id: "els4pjb11vdn"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elf1srut3v16t"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.94,92.83c.68,10.73,2.36,17-7.74,35.89-8,15-49.93,63-66.89,82.23l8,25.05c10.88-14.25,24.61-27.92,35.19-42.42,9.17-12.57,16-20.5,24.69-33.49,7.68-11.51,12.25-15.46,14.73-29.75C146.41,107.22,134.94,92.83,134.94,92.83Z",
    style: {
      fill: "#4090B9",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "101.945px 164.415px"
    },
    className: "animable",
    id: "elg31lwi4n5oq"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elht5qs9t3bm"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.85,210.72c-17.09-19.36-58.7-67.09-66.68-82-10.1-18.87-8.41-25.16-7.74-35.89,0,0-11.46,14.39-8,37.51,2.49,14.29,7,18.24,14.74,29.75,8.67,13,15.79,20,25,32.61,10.52,14.41,23.87,28.87,34.71,43Z",
    style: {
      fill: "#4090B9",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "117.315px 164.265px"
    },
    className: "animable",
    id: "elw9db2xaf5kl"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#32DFEC",
    floodOpacity: 1,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "hover",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff0000",
    floodOpacity: 0.5,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFindDisorder);
export default __webpack_public_path__ + "static/media/FindDisorder.c0911540ff1dd67a6049b1608f9c76e6.svg";
export { ForwardRef as ReactComponent };